import { ClipboardList } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo } from './node-chrome';
import { SaidaNomeada } from './node-saida';

export default function DataCollectionNode({ data }: any) {
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="data_collection"
        dados={data}
        icone={ClipboardList}
        corDoTopo="bg-teal-500"
        corDoIcone="text-teal-600"
        titulo={data.label || 'Fazer uma pergunta'}
        largura="w-[240px]"
      >
        <div className="mt-2 border-t border-border/40 pt-1.5">
          <SaidaNomeada id="valid" rotulo="Respondeu certo" cor="verde" />
          <SaidaNomeada id="invalid" rotulo="Não consegui entender" cor="vermelho" />
        </div>
      </CartaoDoNo>
    </>
  );
}
